import React, { useLayoutEffect } from 'react';
import { Avatar, Box, Flex, keyframes } from '@chakra-ui/react';
import { useIsTyping } from '@outdoorly/react-chat-sdk';
import { AnimatePresence, motion } from 'framer-motion';

const MotionFlex = motion(Flex);

const blink = keyframes`
50% { opacity: 1 }`;

type TypingIndicatorProps = {
  botTyping?: boolean;
  avatar?: string;
  scrollToBottom: () => void;
};
export const TypingIndicator: React.FC<TypingIndicatorProps> = (props) => {
  const { botTyping, avatar, scrollToBottom } = props;
  const isTyping = useIsTyping();

  const shouldShowSelf = isTyping || botTyping;
  useLayoutEffect(() => {
    if (shouldShowSelf) scrollToBottom();
  }, [shouldShowSelf]);
  return (
    <AnimatePresence>
      {shouldShowSelf && (
        <MotionFlex
          align="center"
          key="typingIndicator"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.1 }}
          position="relative"
        >
          <Avatar src={avatar} w="24px" h="24px" mr="4px" ignoreFallback mt="8px" role="presentation" />
          <Box
            background="scheme.backgroundSecondary"
            p="12px"
            borderRadius="16px"
            w="50px"
            marginTop="6px"
            position="relative"
            display="table"
            willChange="transform"
            sx={{
              '& > span:first-of-type': {
                height: '6px',
                width: '6px',
                float: 'left',
                margin: '0 1px',
                backgroundColor: '#9E9EA1',
                display: 'block',
                borderRadius: '50%',
                opacity: 0.4,
                animation: `1s ${blink} infinite`,
                WebkitAnimation: `1s ${blink} infinite`,
                animationDelay: '200ms',
                WebkitAnimationDelay: '200ms'
              },
              '& > span:nth-of-type(2)': {
                height: '6px',
                width: '6px',
                float: 'left',
                margin: '0 1px',
                backgroundColor: '#9E9EA1',
                display: 'block',
                borderRadius: '50%',
                opacity: 0.4,
                animation: `1s ${blink} infinite`,
                WebkitAnimation: `1s ${blink} infinite`,
                animationDelay: '400ms',
                WebkitAnimationDelay: '400ms'
              },
              '& > span:nth-of-type(3)': {
                height: '6px',
                width: '6px',
                float: 'left',
                margin: '0 1px',
                backgroundColor: '#9E9EA1',
                display: 'block',
                borderRadius: '50%',
                opacity: 0.4,
                animation: `1s ${blink} infinite`,
                WebkitAnimation: `1s ${blink} infinite`,
                animationDelay: '600ms',
                WebkitAnimationDelay: '600ms'
              }
            }}
          >
            <span />
            <span />
            <span />
          </Box>
        </MotionFlex>
      )}
    </AnimatePresence>
  );
};
